import React, { useState } from 'react'
import IranIcon from './icons/iranIcon.png'
import inteNational from './icons/international.png'

import { GoChevronLeft } from "react-icons/go";
import TwoStepProgress from './modals/TowStepPrgress';
import Step1 from './Component/Step1';
import Step2 from './Component/Step2';
import { motion } from 'framer-motion';
import { FaAddressBook } from 'react-icons/fa';
import { IoMdAdd } from "react-icons/io";
import CargoService from '../../services/Cargo';
import { useDispatch } from 'react-redux';
import { showToast } from '../../redux/slices/toastSlice';
import { Link, useNavigate } from "react-router-dom";
import Toast from '../../Modals/toast/Toast';


const RegisterCargo = () => {

  const navigate = useNavigate()
  const [currentStep, setCurrenStep] = useState(1)
  const [type, setType] = useState(null)
  const [loadingBtn, setLoadinBtn] = useState(false)

  //origin
  const [originState, setOriginState] = useState(null)
  const [originCity, setOriginCity] = useState(null)


  //dest
  const [destState, setDestState] = useState(null)
  const [destCity, setDestCity] = useState(null)

  //car 
  const [car, setCar] = useState(null)

  //product
  const [product, setProduct] = useState(null)

  //price
  const [price, setPrice] = useState(null)

  //datet
  const [date, setDate] = useState(null)

  //weight
  const [weight, setWeight] = useState(null)
  const [weightType, setWeightType] = useState(null)


  //description
  const [desc, setDesc] = useState(null)

  const dispatch = useDispatch()



  const [errors, setErrors] = useState({
    originState: false,
    originCity: false,
    destState: false,
    destCity: false,
    car: false,
    product: false,
    price: false,
    date: false,
    weight: false,
    desc: false,
  });


  const validateFields = () => {
    let newErrors;
    if(weightType===true){
      newErrors = {

        originCity: !originCity,
        destCity: !destCity,
        car: !car,
        product: !product,
        price: !price,
        date: !date,
        weightType: !weightType,
      };
    }else{
      newErrors = {

        originCity: !originCity,
        destCity: !destCity,
        car: !car,
        product: !product,
        price: !price,
        date: !date,
        weightType: weightType===null,
        weight:!weight,
      };
    }
    console.log(newErrors)

    setErrors(newErrors);

    const isValid = !Object.values(newErrors).some(Boolean);
    return isValid;
  };





  const item = {
    hidden: { opacity: 0, y: 12 },
    show: { opacity: 1, y: 0, transition: { duration: 0.45, ease: 'easeOut' } }
  }

  const [shake, setShake] = useState(false);

  const handleNext = async () => {
    if (currentStep == 1) {
      if (!type) {
        setShake(true);
        setTimeout(() => setShake(false), 500);
        return;
      }
    } else {
     

      const ok = validateFields();

      if (!ok) {

        
      
        const firstErrKey = Object.keys(errors).find((k) => errors[k]);

        return;
      }
      else {

        try {
          setLoadinBtn(true)
          let body;
          if(weightType===true){
            body = {

              "origin": originCity,
              "destination": destCity,
              "type": type,
              "car": car,
              "price": price,
              "product": product,
              "deliveryDate": date,
              "description":desc,
              "load_free":weightType
            }
            
          }else{
            body = {

              "weight": weight,
              "origin": originCity,
              "destination": destCity,
              "load": "ton",
              "type": type,
              "car": car,
              "price": price,
              "product": product,
              "deliveryDate": date,
              "description":desc,
              "load_free":weightType
            }
            
          }
         
          console.log(body)


          const res = await CargoService.createCargo(body)
          console.log(res)
          if (res.status == 200) {
            dispatch(showToast({ message: "بار با موفیت ثبت شد", type: "success" }))

            setTimeout(() => {
              navigate('/cargo')
            }, 1000);

          }
          setLoadinBtn(false)
        }
        catch (err) {
          console.log(err)
          setLoadinBtn(false)
          dispatch(showToast({ message: err?.data?.resdata?.message, type: "error" }))
        }
      }

    }

    setCurrenStep(Math.min(2, currentStep + 1));
  };

  return (
    <>
      <Toast></Toast>
      <div className="w-full flex justify-center items-center flex-col gap-10 min-h-screen  py-10 lg:px-10 px-5">

        {
          currentStep == 1 &&

          <Step1 type={type}
            shake={shake}
            setType={setType}
            currentStep={currentStep}
            setCurrentStep={setCurrenStep}>

          </Step1>

        }
        {
          currentStep == 2 &&

          <Step2
            type={type}
            loadingBtn={loadingBtn}
            setCar={setCar}
            setPrice={setPrice}
            setProduct={setProduct}
            setDate={setDate}
            setDesc={setDesc}
            setWeight={setWeight}
            setOriginCity={setOriginCity}
            setOriginState={setOriginState}
            setDestCity={setDestCity}
            setDestState={setDestState}
            errors={errors}
            setType={setType}
            currentStep={currentStep}
            setCurrentStep={setCurrenStep}
            setWeightType={setWeightType}
            weightType={weightType}
          ></Step2>

        }

        <motion.section
          className="flex justify-start items-start flex-col gap-5 max-w-6xl w-full mx-auto"

          initial="hidden"
          animate="show"
          dir="rtl"
        >
          {/* footer with progress and next button */}
          <motion.div variants={item} className="w-full border-t-[1px] mt-6 border-gray-300 py-4 flex flex-col md:flex-row justify-between items-center gap-4">

            <div className="flex flex-col gap-1 py-2 w-full md:w-auto">
              <TwoStepProgress currentStep={currentStep} />
            </div>

            <div className="flex gap-3 w-full md:w-auto justify-end">
              <button
                onClick={handleNext}
                className='w-full md:w-[140px] h-[40px] bg-special text-white rounded-lg flex items-center justify-center gap-2'
              >
                {
                  currentStep == 1 ?
                    <>
                      <span className="hidden md:inline">مرحله بعد</span>
                      <span className="md:hidden">ادامه</span>
                    </>
                    :
                    <>
                      <span className={`${loadingBtn ? "bg-opacity-60" : "bg-opacity-100"}`}>{loadingBtn ? "منتظر بمانید..." : "ثبت"}</span>

                    </>
                }
                {
                  currentStep == 1 ?
                    <>
                      <GoChevronLeft size={15} />
                    </>
                    :
                    <>
                      <IoMdAdd></IoMdAdd>

                    </>


                }

              </button>
            </div>

          </motion.div>
        </motion.section>




      </div>
    </>
  )
}

export default RegisterCargo
